/**
 * @generated SignedSource<<ca5280f56e827f1af684f0dca913cb86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClientPortalSettings_Query$variables = {};
export type ClientPortalSettings_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly firmPortalSettings: {
      readonly portalCustomDomain: string | null;
      readonly portalSenderDomain: string | null;
      readonly portalReplyTo: string | null;
      readonly defaultAllowFileUpload: boolean | null;
      readonly phaseStatusEnabled: boolean | null;
    } | null;
    readonly portalDataImportStatus: {
      readonly everImported: boolean | null;
      readonly lastSuccessAt: string | null;
      readonly outcome: string | null;
      readonly reconcileSkipped: number | null;
    } | null;
  } | null;
};
export type ClientPortalSettings_Query = {
  variables: ClientPortalSettings_Query$variables;
  response: ClientPortalSettings_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "client_portal_settings"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"client_portal_settings\")"
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "FirmPortalSettings",
  "kind": "LinkedField",
  "name": "firmPortalSettings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalCustomDomain",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalSenderDomain",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalReplyTo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultAllowFileUpload",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phaseStatusEnabled",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PortalDataImportStatus",
  "kind": "LinkedField",
  "name": "portalDataImportStatus",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "everImported",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastSuccessAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "outcome",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reconcileSkipped",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientPortalSettings_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ClientPortalSettings_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5ba7749598af4df45548dd6ea21a9264",
    "id": null,
    "metadata": {},
    "name": "ClientPortalSettings_Query",
    "operationKind": "query",
    "text": "query ClientPortalSettings_Query {\n  viewer {\n    actualPersonId\n    component(name: \"client_portal_settings\")\n    firmPortalSettings {\n      portalCustomDomain\n      portalSenderDomain\n      portalReplyTo\n      defaultAllowFileUpload\n      phaseStatusEnabled\n    }\n    portalDataImportStatus {\n      everImported\n      lastSuccessAt\n      outcome\n      reconcileSkipped\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "394e683269b44c2e0075d18aa7134f9f";

export default node;
